// HTMLの生成はRails側で行うため、全体はComponentを作らない
import {
  onMounted,
} from 'vue'

export default {
  components: {
  },

  setup() {
  },

  mounted() {
    initialize()
  },

  methods: {
  },
}

// ここから下はデザインから持ってきた
const initialize = () => {
  const $slider = $('.map-preview-slider')

  // Slickスライダーの初期化
  $slider.slick({
    arrows: true,
    infinite: true,
    fade: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'ease-out',
    swipeToSlide: true,
    touchThreshold: 10,
    responsive: [
      {
        breakpoint: 701,
        settings: {
          fade: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "10%",
        }
      },
    ]
  })

  $('.map-preview-slider .slick-current .item').addClass('is-active')

  const $activeItem = $('.map-preview-slider .slick-current .item')
  if ($activeItem.length) {
    var id = $activeItem.data('spot')
    $('[data-spot="' + id + '"]').addClass('is-active')
  }

  $slider.on('beforeChange', function () {
    $('.map-preview-slider .item').removeClass('is-active')

    // 現在の `.slick-current` 内の `.item` に `is-active` を追加
    setTimeout(function () {
      $('.map-preview-slider .slick-current .item').addClass('is-active')

      const spotValue = $('.map-preview-slider .slick-current .item').data('spot')
      $('[data-spot]').removeClass('is-active')

      if (spotValue) {
        $('[data-spot="' + spotValue + '"]').addClass('is-active')
      }
    }, 10) // 少し遅延を入れることで、スマホでも動作が安定する
  })

  function moveToActiveSlide() {
    const $activeSlide = $('.map-preview-slider .item.is-active')
    if ($activeSlide.length) {
      var index = $activeSlide.closest('.slick-slide').data('slick-index')
      $slider.slick('slickGoTo', index)
    }
  }
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        moveToActiveSlide()
      }
    })
  })

  $('.map-preview-slider .item').each(function () {
    observer.observe(this, { attributes: true, attributeFilter: ['class'] })
  })


  function updateActiveSpots() {
    $('[data-spot]').removeClass('is-active')
    var $activeItem = $('.map-preview-slider .slick-current .item')
    if ($activeItem.length) {
      var id = $activeItem.data('spot')
      $('[data-spot="' + id + '"]').addClass('is-active')
    }
  }

  function isMobile() {
    return window.matchMedia("(max-width: 700px)").matches
  }

  $('[data-spot]').on('mouseenter', function () {
    if (isMobile()) return
    var id = $(this).data('spot')
    $('[data-spot]').removeClass('is-active')
    $('[data-spot="' + id + '"]').addClass('is-active')
  }).on('mouseleave', function () {
    if (isMobile()) return
    updateActiveSpots()
  })

  $('[data-spot]').on('click', function () {
    if (!isMobile()) return
    var id = $(this).data('spot')
    $('[data-spot]').removeClass('is-active')
    $('[data-spot="' + id + '"]').addClass('is-active')
  })
}
